<template lang="pug">
    .container.mx-auto.spacingTopStandard.spacingBottomStandard
      table.table.table-auto
        tbody
          tr
            td(width='244') Vina Cobos
            td(width='193') Argentinien
            td(width='273')
              a(href='http://www.vinacobos.com‎' target='_blank') http://www.vinacobos.com‎
          tr
            td(width='244') Greenock Creek
            td(width='193') Australien
            td(width='273')
              a(href='http://www.greenockcreekwines.com.au/' target='_blank') http://www.greenockcreekwines.com.au
              | ‎
          tr
            td(width='244') Henschke
            td(width='193') Australien
            td(width='273')
              a(href='http://www.henschke.com.au‎' target='_blank') http://www.henschke.com.au‎
          tr
            td(width='244') Penfolds
            td(width='193') Australien
            td(width='273')
              a(href='http://www.penfolds.com‎' target='_blank') http://www.penfolds.com‎
          tr
            td(width='244') Wild Duck Creek Estate
            td(width='193') Australien
            td(width='273')
              a(href='http://www.wildduckcreekestate.com.au‎' target='_blank') http://www.wildduckcreekestate.com.au‎
          tr
            td(width='244') Almaviva
            td(width='193') Chile
            td(width='273')
              a(href='http://www.almavivawinery.com‎' target='_blank') http://www.almavivawinery.com‎
          tr
            td(width='244') Concha y Toro
            td(width='193') Chile
            td(width='273')
              a(href='http://www.conchaytoro.com/' target='_blank') http://www.conchaytoro.com
          tr
            td(width='244') Errazuriz
            td(width='193') Chile
            td(width='273')
              a(href='http://www.errazuriz.com/' target='_blank') http://www.errazuriz.com
          tr
            td(width='244') Sena
            td(width='193') Chile
            td(width='273')
              a(href='http://www.sena.cl/' target='_blank') http://www.sena.cl
          tr
            td(width='244') Dr. Loosen
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.drloosen.de/' target='_blank') http://www.drloosen.de
          tr
            td(width='244') Egon Müller
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.scharzhof.de‎' target='_blank') http://www.scharzhof.de‎
          tr
            td(width='244') Fritz Haag
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.weingut-fritz-haag.de/' target='_blank') http://www.weingut-fritz-haag.de
              | ‎
          tr
            td(width='244') Geheimrat J. Wegeler
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.wegeler.com/' target='_blank') http://www.wegeler.com
          tr
            td(width='244') Joh. Jos. Prüm
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.jjpruem.com/' target='_blank') http://www.jjpruem.com
          tr
            td(width='244') Karthäuserhof
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.karthaeuserhof.com/' target='_blank') http://www.karthaeuserhof.com
          tr
            td(width='244') Kloster Eberbach
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.kloster-eberbach.de‎' target='_blank') http://www.kloster-eberbach.de‎
          tr
            td(width='244') Reichsgraf von Kesselstatt
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.kesselstatt.com‎' target='_blank') http://www.kesselstatt.com‎
          tr
            td(width='244') Reichsrat von Buhl
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.reichsrat-von-buhl.de‎' target='_blank') http://www.reichsrat-von-buhl.de‎
          tr
            td(width='244') Robert Weil
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.weingut-robert-weil.com/' target='_blank') http://www.weingut-robert-weil.com
          tr
            td(width='244') Schloss Johannisberg
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.schloss-johannisberg.de/' target='_blank') http://www.schloss-johannisberg.de
          tr
            td(width='244') Schloss Reinhartshausen
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.schloss-reinhartshausen.com/' target='_blank') http://www.schloss-reinhartshausen.com
          tr
            td(width='244') Selbach Oster Zeltinger
            td(width='193') Deutschland
            td(width='273')
              a(href='http://www.selbach-oster.de/' target='_blank') http://www.selbach-oster.de
          tr
            td(width='244') Armand Rousseau
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.domaine-rousseau.com‎' target='_blank') http://www.domaine-rousseau.com‎
          tr
            td(width='244') Cheval Blanc
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chevalblanc.com/' target='_blank') http://www.chevalblanc.com
          tr
            td(width='244') Comte Liger Belair
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.liger-belair.fr/' target='_blank') http://www.liger-belair.fr
          tr
            td(width='244') Comtes Lafon
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.comtes-lafon.fr/' target='_blank') http://www.comtes-lafon.fr
          tr
            td(width='244') Cos d’Estournel
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.estournel.com/' target='_blank') http://www.estournel.com
          tr
            td(width='244') Ducru Beaucaillou
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chateau-ducru-beaucaillou.com/' target='_blank') http://www.chateau-ducru-beaucaillou.com
          tr
            td(width='244') Dugat Py
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.dugat-py.com/' target='_blank') http://www.dugat-py.com
          tr
            td(width='244') Faiveley
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.domaine-faiveley.com/' target='_blank') http://www.domaine-faiveley.com
              | ‎
          tr
            td(width='244') Georges et Christophe Roumier
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.roumier.com/' target='_blank') http://www.roumier.com‎
          tr
            td(width='244') Gruaud Larose
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.gruaud-larose.com/' target='_blank') http://www.gruaud-larose.com
              | ‎
          tr
            td(width='244') Haut Brion
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.haut-brion.com/' target='_blank') http://www.haut-brion.com
          tr
            td(width='244') Jacques Frederic Mugnier
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.mugnier.fr/' target='_blank') http://www.mugnier.fr‎
          tr
            td(width='244') Jean Louis Chave
            td(width='193') Frankreich
            td(width='273')
              a(href='http://hermite.fr/domaine-jean-louis-chave' target='_blank') http://hermite.fr/domaine-jean-louis-chave
          tr
            td(width='244') Krug
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.krug.com/' target='_blank') http://www.krug.com‎
          tr
            td(width='244') Lafite Rothschild
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.lafite.com/' target='_blank') http://www.lafite.com‎
          tr
            td(width='244') Lalou Bize Leroy
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.domaine-leroy.com/' target='_blank') http://www.domaine-leroy.com
          tr
            td(width='244') Latour
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chateau-latour.com/' target='_blank') http://www.chateau-latour.com‎
          tr
            td(width='244') Leflaive
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.leflaive.fr/' target='_blank') http://www.leflaive.fr‎
          tr
            td(width='244') Leoville Barton
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.leoville-barton.com/' target='_blank') http://www.leoville-barton.com
          tr
            td(width='244') Leoville las Cases
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.leoville-las-cases.com/' target='_blank') http://www.leoville-las-cases.com‎
          tr
            td(width='244') Leoville Poyferre
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.leoville-poyferre.fr/' target='_blank') http://www.leoville-poyferre.fr
          tr
            td(width='244') Margaux
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chateau-margaux.com/' target='_blank') http://www.chateau-margaux.com‎
          tr
            td(width='244') Meo Camuzet
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.meo-camuzet.com/' target='_blank') http://www.meo-camuzet.com
          tr
            td(width='244') Moet et Chandon
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.moet.com/' target='_blank') http://www.moet.com‎
          tr
            td(width='244') Montrose
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chateau-montrose.com/' target='_blank') http://www.chateau-montrose.com‎
          tr
            td(width='244') Mouton Rothschild
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chateau-mouton-rothschild.com/' target='_blank') http://www.chateau-mouton-rothschild.com‎
          tr
            td(width='244') Palmer
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.chateau-palmer.com/' target='_blank') http://www.chateau-palmer.com
          tr
            td(width='244') Romanee Conti
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.romanee-conti.fr/' target='_blank') http://www.romanee-conti.fr
          tr
            td(width='244') Yquem
            td(width='193') Frankreich
            td(width='273')
              a(href='http://www.yquem.fr/' target='_blank') http://www.yquem.fr‎
          tr
            td(width='244') Antinori
            td(width='193') Italien
            td(width='273')
              a(href='http://www.antinori.it/' target='_blank') http://www.antinori.it‎
          tr
            td(width='244') Biondi Santi
            td(width='193') Italien
            td(width='273')
              a(href='http://www.biondisanti.it/' target='_blank') http://www.biondisanti.it
          tr
            td(width='244') Bruno Giacosa
            td(width='193') Italien
            td(width='273')
              a(href='http://www.brunogiacosa.it/' target='_blank') http://www.brunogiacosa.it
          tr
            td(width='244') Gaja
            td(width='193') Italien
            td(width='273')
              a(href='http://www.gaja.com/' target='_blank') http://www.gaja.com
          tr
            td(width='244') Giacomo Conterno
            td(width='193') Italien
            td(width='273')
              a(href='http://www.conterno.it/' target='_blank') http://www.conterno.it
          tr
            td(width='244') Mascarello Giuseppe e Figlio
            td(width='193') Italien
            td(width='273')
              a(href='http://www.mascarello1881.com/' target='_blank') http://www.mascarello1881.com
              | ‎
          tr
            td(width='244') Ornellaia
            td(width='193') Italien
            td(width='273')
              a(href='http://www.ornellaia.com/' target='_blank') http://www.ornellaia.com
          tr
            td(width='244') Roberto Voerzio
            td(width='193') Italien
            td(width='273')
              a(href='http://www.voerzioroberto.it/' target='_blank') http://www.voerzioroberto.it‎
          tr
            td(width='244') San Guido
            td(width='193') Italien
            td(width='273')
              a(href='http://www.tenutasanguido.com/' target='_blank') http://www.tenutasanguido.com‎
          tr
            td(width='244') Soldera
            td(width='193') Italien
            td(width='273')
              a(href='http://www.soldera.it/' target='_blank') http://www.soldera.it
              | ‎
          tr
            td(width='244') Barbeito
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.vinhosbarbeito.com/' target='_blank') http://www.vinhosbarbeito.com‎
          tr
            td(width='244') Burmester
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.burmester.pt/' target='_blank') http://www.burmester.pt
          tr
            td(width='244') Cossart Gordon
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.cossartgordon.com/' target='_blank') http://www.cossartgordon.com‎
          tr
            td(width='244') Delaforce
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.delaforce.com/' target='_blank') http://www.delaforce.com‎
          tr
            td(width='244') Niepoort
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.niepoort-vinhos.com/' target='_blank') http://www.niepoort-vinhos.com
          tr
            td(width='244') Quinta do Noval
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.quintadonoval.com/' target='_blank') http://www.quintadonoval.com‎
          tr
            td(width='244') Warre’s
            td(width='193') Portugal
            td(width='273')
              a(href='http://www.warre.com/' target='_blank') http://www.warre.com
          tr
            td(width='244') Artadi
            td(width='193') Spanien
            td(width='273')
              a(href='http://www.artadi.com/' target='_blank') http://www.artadi.com‎
          tr
            td(width='244') Clos Erasmus
            td(width='193') Spanien
            td(width='273')
              a(href='http://www.closerasmus.com/' target='_blank') http://www.closerasmus.com‎
          tr
            td(width='244') Contador
            td(width='193') Spanien
            td(width='273')
              a(href='http://www.bodegacontador.com/' target='_blank') http://www.bodegacontador.com
          tr
            td(width='244') Remirez de Ganuza
            td(width='193') Spanien
            td(width='273')
              a(href='http://www.remirezdeganuza.com/' target='_blank') http://www.remirezdeganuza.com
              | ‎
          tr
            td(width='244') Vega Sicilia
            td(width='193') Spanien
            td(width='273')
              a(href='http://www.vega-sicilia.com/' target='_blank') http://www.vega-sicilia.com
          tr
            td(width='244') Beyerskloof
            td(width='193') Südafrika
            td(width='273')
              a(href='http://www.beyerskloof.co.za/' target='_blank') http://www.beyerskloof.co.za
          tr
            td(width='244') Bouchard Finlayson
            td(width='193') Südafrika
            td(width='273')
              a(href='http://www.bouchardfinlayson.co.za/' target='_blank') http://www.bouchardfinlayson.co.za‎
          tr
            td(width='244') De Trafford
            td(width='193') Südafrika
            td(width='273')
              a(href='http://www.detrafford.co.za/' target='_blank') http://www.detrafford.co.za
          tr
            td(width='244') Klein Constantia
            td(width='193') Südafrika
            td(width='273')
              a(href='http://www.kleinconstantia.com/' target='_blank') http://www.kleinconstantia.com‎
          tr
            td(width='244') The Sadie Family
            td(width='193') Südafrika
            td(width='273')
              a(href='http://www.thesadiefamily.com/' target='_blank') http://www.thesadiefamily.com
          tr
            td(width='244') Vergelegen
            td(width='193') Südafrika
            td(width='273')
              a(href='http://www.vergelegen.co.za/' target='_blank') http://www.vergelegen.co.za
          tr
            td(width='244') Abreu Vineyard
            td(width='193') USA
            td(width='273')
              a(href='http://www.abreuvineyard.com/' target='_blank') http://www.abreuvineyard.com
          tr
            td(width='244') Bryant Family Vineyard
            td(width='193') USA
            td(width='273')
              a(href='http://www.bryantwines.com/' target='_blank') http://www.bryantwines.com‎
          tr
            td(width='244') Dalla Valle Vineyards
            td(width='193') USA
            td(width='273')
              a(href='http://www.dallavallevineyards.com/' target='_blank') http://www.dallavallevineyards.com
              | ‎
          tr
            td(width='244') Harlan Estate
            td(width='193') USA
            td(width='273')
              a(href='http://www.harlanestate.com/' target='_blank') http://www.harlanestate.com‎
          tr
            td(width='244') Schrader Cellars
            td(width='193') USA
            td(width='273')
              a(href='http://www.schradercellars.com/' target='_blank') http://www.schradercellars.com‎
          tr
            td(width='244') Screaming Eagle
            td(width='193') USA
            td(width='273')
              a(href='http://www.screamingeagle.com/' target='_blank') http://www.screamingeagle.com
          tr
            td(width='244') Sine Qua Non
            td(width='193') USA
            td(width='273')
              a(href='http://www.sinequanon.com/' target='_blank') http://www.sinequanon.com‎

</template>

<script>
export default {
    name: 'Table3'
    // Top Weingüter
};
</script>

<style lang="sass" scoped>
.table
  @apply table w-full

  tr:nth-child(odd)
    @apply bg-gray-100

  &:first-child
    td
    @apply border-t
  td, th
    @apply border-b border-r
    padding: 6px 10px
    &:first-child
      @apply border-l
</style>
